import authRedux from './auth/reducer';

export default {
  auth: authRedux,
};
